import { render } from "./reply.vue?vue&type=template&id=68412f98&scoped=true"
import script from "./reply.vue?vue&type=script&lang=js"
export * from "./reply.vue?vue&type=script&lang=js"

import "./reply.vue?vue&type=style&index=0&id=68412f98&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68412f98"]])

export default __exports__